import { GlobalHeader } from '@/app/components/layout';

const EssenceHeader = () => {
  return <GlobalHeader logo="essence" />;
};

export default EssenceHeader;
